<script lang="ts">import { refreshVipState } from "@infinitro/global";
import { onMount } from "svelte";
import TopSectionDesktop from "./top-section-desktop.svelte";
import TopSectionMobile from "./top-section-mobile.svelte";
onMount(() => {
	refreshVipState();
});
</script>

<div class="top-section-desktop">
	<TopSectionDesktop />
</div>

<div class="top-section-mobile">
	<TopSectionMobile />
</div>

<style>
	.top-section-desktop {

		display: none;

		height: auto;

		width: 100%
}

	@media (min-width: 1280px) {
		.top-section-desktop {

				display: flex
		}
	}

	.top-section-mobile {

		display: flex;

		height: auto;

		width: 100%
}

	@media (min-width: 1280px) {
		.top-section-mobile {

				display: none
		}
	}
</style>
